// VARS

// FUNCTIONS
function onHoverSticky(event)
{
    event.preventDefault();

    let imgNonHover = this.querySelector('img#sticky-nonhover');
    let imgHover = this.querySelector('img#sticky-hover');

    imgNonHover.classList.remove('d-inline-block');
    imgNonHover.classList.add('d-none');

    imgHover.classList.add('d-inline-block');
    imgHover.classList.remove('d-none');
}
function onHoverEndSticky(event)
{
    event.preventDefault();

    let imgNonHover = this.querySelector('img#sticky-nonhover');
    let imgHover = this.querySelector('img#sticky-hover');

    imgNonHover.classList.add('d-inline-block');
    imgNonHover.classList.remove('d-none');

    imgHover.classList.remove('d-inline-block');
    imgHover.classList.add('d-none');
}

// LISTENERS
document.querySelector('.sticky').addEventListener('mouseover', onHoverSticky);
document.querySelector('.sticky').addEventListener('mouseout', onHoverEndSticky);


// EXECUTE